import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ModeledEvents } from 'src/app/shared/models/management/modeles-events';
import { StatutsPoints } from 'src/app/shared/models/management/statuts-points';
import { TypeSeances } from 'src/app/shared/models/management/type-seances';

@Injectable({
  providedIn: 'root',
})
export class IDelibeManagementService {
  public apiBaseUrl: string;

  constructor(public http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.apiBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
  }

  getManagementModelesEvenements(): Observable<ModeledEvents[]> {
    return this.http.get<ModeledEvents[]>(`${this.apiBaseUrl}/Management/ModelesEvenements`);
  }

  getManagementstatutsPoints(): Observable<StatutsPoints[]> {
    return this.http.get<StatutsPoints[]>(`${this.apiBaseUrl}/Management/StatutsPoints`);
  }

  getManagementTypeSeances(): Observable<TypeSeances[]> {
    return this.http.get<TypeSeances[]>(`${this.apiBaseUrl}/Management/TypesSeances`);
  }

  postModelePointFromPoint(id: number, data): Observable<{description: string}> {
    return this.http.post<{description: string}>(`${this.apiBaseUrl}/Management/ModelesPointsFromPoint?pointId=${id}`, data);
  }
}